export default {
  getHead: () => {
    return [{name: '학교명'}, {name: '학교명'}, {name: '평가종류'}, {name: '재해형태'}, {name: '1~2(L)'}, {name: '3~4(ML)'}, {name: '6(M)'}, {name: '8~9(H)'}, {name: '12~16(HH)'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.section // 부서명
      case 1: return func.getContent(value).stdInfo.field_name // 사업장명
      case 2: return func.getContent(value).inputA_1 // 평가종류
      case 3: return func.getContent(value).disasterList.join(" ") // 재해형태
      case 4: return func.getContent(value).sum_L.toString() // 합계
      case 5: return func.getContent(value).sum_ML.toString() // 합계
      case 6: return func.getContent(value).sum_M.toString() // 합계
      case 7: return func.getContent(value).sum_H.toString() // 합계
      case 8: return func.getContent(value).sum_HH.toString() // 합계
      case 9: return func.getCreatedDate(value.created_at) // 작성일

      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.disasterString*[:default_disaster]')

    switch (nav.value.searchType) {
    case '학교명': returnData.push('content$body.stdInfo.section*%[:default_skw]%%'); break
    case '학교명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '평가종류': returnData.push('content$body.inputA_1*%[:default_skw]%'); break
    }

    return returnData
  },
}
